import React, { useEffect, useState, createRef } from "react";
import { useStore } from "../../context";
import { httpPost, httpGet, httpPostProxy } from "../../servicios";
import { placeToPay, user, password, urlReferencia, urlRespuesta, urlPago, saveLog, saveCab, saveDet, PROD } from "../../utils";
import PagoWebCab from '../../models/PagoWebCab';
import PagoWebDet from "../../models/PagoWebDet";
import LogPago from "../../models/LogPago";
import RedirectionAuth from "../../utils/autentication";
import sendLog from "../../utils/logs";
import { navigate } from "@reach/router";
import Swal from "sweetalert2";
import "../../styles/theme.css";

var moment = require('moment');
var _ = require('lodash');

const creditI = require("../../images/logos/logos_EC.png")
const bannerDiners = require("../../images/logos/bannerdiners.jpg")

function ccyFormat(num) {
  return `${num.toFixed(2)}`;
}

const thStyle = { padding: "12px 10px", textAlign: "left", fontSize: "0.78rem", fontWeight: 600, letterSpacing: "0.5px", textTransform: "uppercase" };
const tdStyle = { padding: "10px 10px", fontSize: "0.84rem" };

export default function Cart(props) {
  const { state, dispatch } = useStore();
  const [checked, setChecked] = useState(false);
  const [faqOpen, setFaqOpen] = useState(false);
  const [itemsToPay, setItemsToPay] = useState();
  const buttonPayment = createRef();

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  //-------------------------------------------------------------------------
  // Suma el total y setea los items a pagar
  //-------------------------------------------------------------------------

  useEffect(() => {
    let sumatoria = 0;
    state.cart.map((item) => {
      sumatoria = sumatoria + parseFloat(item.valor);
    });
    setTotal(sumatoria.toFixed(2));
    setItemsToPay({
      order_amount: sumatoria,
      order_description: "Pago pensiones",
    });
    setChecked(false);
  }, [state.cart]);

  //-------------------------------------------------------------------------
  // Valida la eliminacion basado en el codigo del Rubro
  //-------------------------------------------------------------------------
  const validateRemove = (row) => {
    var _newArray = [];
    state.cart.map((item) => {
      if (item.codEst === row.codEst) {
        _newArray.push(item)
      }
    })
    _newArray = _newArray.sort((a, b) => {
      if (b.codRub < a.codRub) return 1;
      if (b.codRub > a.codRub) return -1;
      return 0;
    })
    var length = _newArray.length;
    var index = _.findIndex(_newArray, { 'codRub': row.codRub });
    if ((length - 1) === index) {
      dispatch({ type: "REMOVE_CART", payload: row });
    } else {
      Swal.fire({ icon: 'warning', title: 'Orden requerido', text: 'Remueva de mayor a menor por estudiante según el campo Cod. Rubro', confirmButtonColor: '#0d1b3e' });
      return;
    }
  }

  const createKeys = (keys) => {
    dispatch({ type: "ADD_KEYS", payload: keys });
  };

  const createIdPayment = (id) => {
    dispatch({ type: "ID_PAYMENT", payload: id });
  };

  //-------------------------------------------------------------------------
  // Metodo de Pagar, llamada a Place To Pay
  //-------------------------------------------------------------------------
  const payment = async (total) => {
    try {

      if (checked === false) {
        Swal.fire({ icon: 'warning', title: 'Términos y Condiciones', text: 'Debe aceptar los términos y condiciones para continuar con su pago.', confirmButtonColor: '#0d1b3e' });
        return;
      }
      setLoading(true);
      var authGenerator = "";
      var auth = ""
      var referencia = null;

      let consulta = await httpGet(saveCab + "/" + sessionStorage.getItem("username"), state.token);
      if (consulta.cod !== 0) {
        Swal.fire({ icon: 'error', title: 'Error', text: consulta.mensaje, confirmButtonColor: '#0d1b3e' });
        setLoading(false);
        return;
      }

      authGenerator = new RedirectionAuth(user, password);
      auth = authGenerator.asObject();
      createKeys(auth);

      var hoy = moment();
      hoy.add(20, 'minutes');
      const { cart } = state;
      var tipIden = "CI";
      if (cart[0].tipIden === "RC") {
        tipIden = "RUC"
      }

      let _referencia = await httpGet(urlReferencia + sessionStorage.getItem("username"), state.token);
      if (_referencia.cod !== 0) {
        Swal.fire({ icon: 'error', title: 'Error', text: _referencia.mensaje, confirmButtonColor: '#0d1b3e' });
        return;
      }

      referencia = sessionStorage.getItem("username") + _referencia.data;

      let telefono = "";
      try {
        if ((cart[0].numTell).split('/').length > 0) {
          if ((cart[0].numTell).split('/').length === 1) {
            telefono = (cart[0].numTell).split('/')[0].trimEnd()
          } else {
            telefono = (cart[0].numTell).split('/')[1].trimEnd()
          }
        }
      } catch (error) {
        telefono = " "
      }

      let data = {
        "auth": {
          "login": auth.login,
          "seed": auth.seed,
          "nonce": auth.nonce,
          "tranKey": auth.tranKey
        },
        "locale": "es_EC",
        "buyer": {
          "document": sessionStorage.getItem("username"),
          "documentType": tipIden,
          "name": " ",
          "surname": " ",
          "email": cart[0].email,
          "mobile": telefono,
          "address": {
            "street": cart[0].dirTur,
            "city": "Guayaquil",
            "country": "EC"
          }
        },
        "payment": {
          "reference": referencia,
          "description": "Pago pensiones",
          "amount": {
            "currency": "USD",
            "total": `${total}`
          },
          "allowPartial": false
        },
        "expiration": hoy,
        "returnUrl": urlRespuesta + sessionStorage.getItem("username") + auth.nonce,
        "userAgent": navigator.userAgent,
        "ipAddress": "40.76.73.208"
      }

      let response = await httpPostProxy(urlPago, data, placeToPay);
      if (response.cod !== 0) {
        Swal.fire({ icon: 'error', title: 'Error', text: response.mensaje, confirmButtonColor: '#0d1b3e' });
        setLoading(false);
        return;
      }
      if (JSON.parse(response.data).status.status === 'OK') {
        let data = JSON.parse(response.data);
        let date = moment(data.status.date);
        createIdPayment(JSON.parse(response.data).requestId);
        var _logArray = [];

        state.cart.forEach((item, index) => {
          var logPago = new LogPago(
            data.requestId,
            (index + 1).toString(),
            "USD",
            item.valor,
            data.status.reason,
            "PENDING-" + data.status.message,
            date.format("YYYY-MM-DD"),
            date.format("HH:mm"),
            sessionStorage.getItem("username"),
            " ",
            item.codRub,
            item.codEst,
            item.codNiv,
            item.periodo,
            sessionStorage.getItem("username"),
            referencia
          )
          _logArray.push(logPago)
        })

        let isLog = false;
        let isCab = false;
        let isDet = false;

        isLog = await httpPost(saveLog, _logArray, state.token)
          .then(async (res) => {
            isLog = true;
            return isLog;
          })
          .catch(err => console.log("Error en guardar log", err))

        const pagoCab = new PagoWebCab(
          data.requestId,
          "USD",
          total,
          "TAR",
          "",
          "",
          "",
          tipIden,
          sessionStorage.getItem("username"),
          " ",
          date.format("YYYY-MM-DD"),
          date.format("HH:mm"),
          data.status.reason,
          "PENDING-" + data.status.message,
          sessionStorage.getItem("username"),
          "WEB",
          "",
          "",
          "",
          "",
          sessionStorage.getItem("username"),
          referencia,
          data.processUrl ? data.processUrl : "Sin processUrl retornado de place to Pay",
          "PE"
        )

        isCab = await httpPost(saveCab, pagoCab, state.token).then(async (result) => {
          if (result.cod === 0) {
            let _data = result.data;
            let pagoDet = [];
            state.cart.forEach((item, index) => {
              var _pagoDet = new PagoWebDet(
                _data.idSobre,
                (index + 1).toString(),
                item.valor,
                item.nomEst.trim(),
                "",
                item.abrRub,
                _data.fechaProceso,
                sessionStorage.getItem("username"),
                "",
                "",
                "",
                "",
                item.periodo,
                item.codNiv,
                item.codEst,
                item.codRub,
                _data.fechaProceso,
                "",
                "",
                "",
                "",
                "",
                0,
                "",
                0
              )
              pagoDet.push(_pagoDet)
            })

            sendLog(PROD, "Carrito Pensiones:", JSON.stringify(state.cart), JSON.parse(response.data).requestId, state.token)
            sendLog(PROD, "Detalle Pensiones", JSON.stringify(pagoDet), JSON.parse(response.data).requestId, state.token)
            isDet = await httpPost(saveDet, pagoDet, state.token)
              .then(async (result) => {
                if (result.data.length === pagoDet.length) {
                  isDet = true;
                  return isDet;
                }
              })
              .catch(err => console.log("Error al guardar detalle:", err))

            return true;
          }
        });

        if (isLog && isCab && isDet) {
          sendLog(PROD, "Carrito de pensiones en estado OK", response.data, JSON.parse(response.data).requestId, state.token);
          window.location.assign(JSON.parse(response.data).processUrl);
        } else {
          sendLog(PROD, "Error en Carrito de pensiones", "Estado de banderas.Log:" + isLog + "Cab:" + isCab + "Det:" + isDet, JSON.parse(response.data).requestId, state.token);
          Swal.fire({ icon: 'error', title: 'Error', text: 'Hubo un error en la transacción', confirmButtonColor: '#0d1b3e' });
        }

        setLoading(false);
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: JSON.parse(response.data).status.message, confirmButtonColor: '#0d1b3e' });
        setLoading(false);
        return;
      }
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se ha podido proceder con el pago.', confirmButtonColor: '#0d1b3e' });
      console.log(error);
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 300 }}>
        <div className="modern-spinner"></div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 1100, margin: "0 auto" }}>
      {/* Back Navigation */}
      <div style={{ marginBottom: 16, display: 'flex', gap: 12 }}>
        <button 
          onClick={() => navigate("/menuMain")} 
          className="btn-modern btn-outline"
          style={{ padding: '10px 20px', display: 'inline-flex', alignItems: 'center', gap: 8, width: 'auto' }}
        >
          ⬅️ Volver al Menú
        </button>
        <button 
          onClick={() => navigate("/pension/list")} 
          className="btn-modern btn-outline"
          style={{ padding: '10px 20px', display: 'inline-flex', alignItems: 'center', gap: 8, width: 'auto' }}
        >
          📋 Ver Pensiones
        </button>
      </div>
      
      {/* Cart Header */}
      <div className="modern-card" style={{ marginBottom: 24 }}>
        <div className="modern-card-header">
          <h3 style={{ margin: 0 }}>🛒 Carrito de Pagos</h3>
          <span style={{ fontSize: "0.85rem", opacity: 0.7 }}>
            {state.cart.length} {state.cart.length === 1 ? "rubro" : "rubros"} en el carrito
          </span>
        </div>

        {state.cart.length === 0 ? (
          <div style={{ textAlign: "center", padding: "48px 20px", color: "#6c757d" }}>
            <div style={{ fontSize: "3rem", marginBottom: 12 }}>🛒</div>
            <p style={{ fontSize: "1.1rem", fontWeight: 500 }}>El carrito está vacío</p>
            <p style={{ fontSize: "0.85rem" }}>Agregue rubros desde la lista de pensiones</p>
          </div>
        ) : (
          <div className="table-modern-wrapper" style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 800 }}>
              <thead>
                <tr style={{ background: "#0d1b3e", color: "#fff" }}>
                  <th style={thStyle}>Periodo</th>
                  <th style={thStyle}>Cod. Est</th>
                  <th style={thStyle}>Nombres</th>
                  <th style={thStyle}>Cod. Rubro</th>
                  <th style={thStyle}>Nivel</th>
                  <th style={thStyle}>Curso</th>
                  <th style={thStyle}>Rubro</th>
                  <th style={{ ...thStyle, textAlign: "right" }}>Valor</th>
                  <th style={thStyle}></th>
                </tr>
              </thead>
              <tbody>
                {state.cart.map((row, idx) => (
                  <tr key={row.codRub + "-" + row.codEst} style={{ background: idx % 2 === 0 ? "#fff" : "#f8f9fa", borderBottom: "1px solid #e9ecef" }}>
                    <td style={tdStyle}>{row.periodo}</td>
                    <td style={tdStyle}>{row.codEst}</td>
                    <td style={tdStyle}>{row.nomEst}</td>
                    <td style={tdStyle}>{row.codRub}</td>
                    <td style={tdStyle}>{row.desCos}</td>
                    <td style={tdStyle}>{row.abrCur}</td>
                    <td style={tdStyle}>{row.abrRub}</td>
                    <td style={{ ...tdStyle, textAlign: "right", fontWeight: 600 }}>$ {ccyFormat(row.valor)}</td>
                    <td style={tdStyle}>
                      <button
                        onClick={() => validateRemove(row)}
                        style={{
                          background: "linear-gradient(135deg, #dc3545, #c82333)",
                          color: "#fff",
                          border: "none",
                          borderRadius: 6,
                          padding: "6px 14px",
                          fontSize: "0.78rem",
                          fontWeight: 600,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                          transition: "all 0.2s",
                          whiteSpace: "nowrap",
                        }}
                      >
                        ✕ Remover
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr style={{ background: "#e8ecf4", borderTop: "2px solid #0d1b3e" }}>
                  <td colSpan={6}></td>
                  <td style={{ ...tdStyle, fontWeight: 700, fontSize: "1rem" }}>Total</td>
                  <td style={{ ...tdStyle, textAlign: "right", fontWeight: 700, fontSize: "1.1rem", color: "#0d1b3e" }}>$ {total}</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>

      {/* Banner Diners */}
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
        <img src={bannerDiners} alt="Promoción Diners Club" style={{ width: "100%", maxWidth: 800, borderRadius: 10, boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }} />
      </div>

      {/* Warning */}
      <div style={{ background: "linear-gradient(135deg, #fff3cd, #ffeeba)", border: "1px solid #ffc107", borderRadius: 10, padding: "16px 24px", marginBottom: 24, display: "flex", alignItems: "center", gap: 12 }}>
        <span style={{ fontSize: "1.5rem" }}>⚠️</span>
        <span style={{ color: "#856404", fontWeight: 600, fontSize: "0.9rem" }}>
          Los pagos en esta plataforma se procesan en un plazo de 24 horas laborables
        </span>
      </div>

      {/* Terms & Conditions */}
      <div className="modern-card" style={{ marginBottom: 24 }}>
        <div className="modern-card-header">
          <h3 style={{ margin: 0 }}>📜 Términos y Condiciones</h3>
        </div>
        <div style={{ maxHeight: 250, overflowY: "auto", padding: "16px 20px", fontSize: "0.85rem", lineHeight: 1.7, color: "#444", background: "#fafbfc", borderRadius: "0 0 12px 12px" }}>
          <p>
            El acceso y uso de este sitio web se rige bajo los términos descritos a continuación.
            El Horario de atención de los pagos es de Lunes a Domingo de 06:00 a 23:00, y serán
            procesados (Factura electrónica) el primer día laborable.
            Los pagos serán con tarjetas de débito, corrientes y diferidos con las siguientes tarjetas:
            Produbanco, Internacional, Bolivariano, Guayaquil, Diners Club Internacional, Discover,
            Visa Banco Pichincha y Mastercard Banco Pichincha.
          </p>
          <h4 style={{ color: "#0d1b3e", marginTop: 16 }}>NOTIFICACIÓN</h4>
          <p>
            LEA LOS PRESENTES TÉRMINOS Y CONDICIONES CUIDADOSAMENTE. AL ACCEDER A ESTE SITIO Y A CUALQUIER PÁGINA DEL MISMO SE COMPROMETE A CUMPLIR CON LOS TÉRMINOS Y CONDICIONES QUE APARECEN A CONTINUACIÓN. EN CASO DE NO ESTAR DE ACUERDO CON LOS SIGUIENTES TÉRMINOS Y CONDICIONES NO ACCEDA A ESTE SITIO, O A CUALQUIER PÁGINA DEL MISMO.
          </p>
          <p>
            Todos los pagos que se ejecuten mediante este sitio web se regirán por los términos y condiciones contenidos en este documento, así como por la legislación aplicable en la República del Ecuador. Los servicios sólo estarán disponibles para personas que tengan capacidad legal para contratar.
          </p>
          <h4 style={{ color: "#0d1b3e", marginTop: 16 }}>Usuario o Cliente</h4>
          <p>
            La Academia Naval Almirante Illingworth proveerá al Padre de Familia su usuario y contraseña para poder ingresar al portal de pagos.
          </p>
          <h4 style={{ color: "#0d1b3e", marginTop: 16 }}>Contraseña</h4>
          <p>
            El cliente registrado asume totalmente la responsabilidad por el mantenimiento de la confidencialidad de su contraseña registrada en este sitio web. Dicha contraseña es de uso personal y su entrega a terceros no involucra responsabilidad de la Academia Naval Almirante Illingworth en caso de mala utilización.
          </p>
          <h4 style={{ color: "#0d1b3e", marginTop: 16 }}>CONSIDERACIONES</h4>
          <p>
            a. El cliente puede solicitar un REVERSO de la transacción sólo en el mismo día que generó el pago, enviando un correo a muquillas@anai.edu.ec, indicando nombre del cadete, la fecha, # de transacción.
          </p>
          <p>
            b. El cliente puede realizar una CANCELACIÓN de su transacción en la misma página web y antes de haber hecho click en el Botón de Pago.
          </p>
          <h4 style={{ color: "#0d1b3e", marginTop: 16 }}>Idioma</h4>
          <p>El idioma del presente acuerdo y de sus documentos adicionales es el español, que en cualquier caso prevalecerá sobre traducciones o versiones en otro idioma.</p>
          <h4 style={{ color: "#0d1b3e", marginTop: 16 }}>Ley aplicable</h4>
          <p>
            El presente Contrato se regirá por las leyes de la República del Ecuador. En caso de surgir algún tipo de controversia, las partes renuncian domicilio y se sujetan a los jueces competentes de la ciudad de Guayaquil, así como al trámite ejecutivo o verbal sumario.
          </p>
          <h4 style={{ color: "#0d1b3e", marginTop: 16 }}>Límite de responsabilidad</h4>
          <p>
            En ningún caso la Academia Naval Almirante Illingworth será responsable de algún daño, incluyendo, sin límite, daños, pérdidas o gastos directos, indirectos, inherentes o consecuentes, que surjan en relación con este sitio o su uso o imposibilidad de uso por alguna de las partes.
          </p>
        </div>
      </div>

      {/* Checkbox + Pay + FAQ */}
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 16, marginBottom: 24 }}>
        <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: "0.9rem", fontWeight: 600, color: "#333" }}>
          <input type="checkbox" checked={checked} onChange={handleChange} style={{ width: 18, height: 18, accentColor: "#0d1b3e" }} />
          Aceptar Términos y Condiciones
        </label>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <button onClick={() => setFaqOpen(true)} style={{ background: "transparent", border: "2px solid #0d1b3e", color: "#0d1b3e", borderRadius: 8, padding: "10px 20px", fontWeight: 600, fontSize: "0.85rem", cursor: "pointer", transition: "all 0.2s" }}>
            ❓ Preguntas Frecuentes
          </button>
          <button
            ref={buttonPayment}
            onClick={() => payment(total)}
            disabled={state.cart.length === 0}
            className="btn-modern btn-pay"
            style={{ minWidth: 180 }}
          >
            💳 Pagar $ {total}
          </button>
        </div>
      </div>

      {/* FAQ Modal */}
      {faqOpen && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setFaqOpen(false)}>
          <div style={{ background: "#fff", borderRadius: 14, maxWidth: 700, width: "100%", maxHeight: "80vh", overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }} onClick={(e) => e.stopPropagation()}>
            <div style={{ background: "linear-gradient(135deg, #0d1b3e, #1a3068)", color: "#fff", padding: "20px 24px", fontWeight: 700, fontSize: "1.1rem" }}>
              PREGUNTAS FRECUENTES SOBRE PAGOS ELECTRÓNICOS
            </div>
            <div style={{ padding: "20px 24px", maxHeight: "60vh", overflowY: "auto", fontSize: "0.88rem", lineHeight: 1.7 }}>
              <h4>1.- ¿Qué es Placetopay?</h4>
              <p>Placetopay es la plataforma de pagos electrónicos que usa <strong>ANAI</strong> para procesar en línea las transacciones generadas en la tienda virtual.</p>
              <h4>2.- ¿Cómo puedo pagar?</h4>
              <p>Usted podrá pagar a través de: <strong>Diners, Discover, Visa y MasterCard</strong>; de todos los bancos con pago corriente y en los diferidos, únicamente las tarjetas emitidas por Banco Pichincha, Diners, Loja, BGR y Manabí.</p>
              <h4>3.- ¿Es seguro ingresar mis datos bancarios?</h4>
              <p>Para proteger tus datos, <strong>ANAI</strong> delega en Placetopay la captura de la información sensible. Nuestra plataforma cumple con los más altos estándares PCI DSS de seguridad.</p>
              <h4>4.- ¿Puedo realizar el pago cualquier día?</h4>
              <p>Sí, podrás realizar tus pagos en línea los 7 días de la semana, las 24 horas del día.</p>
              <h4>5.- ¿Puedo cambiar la forma de pago?</h4>
              <p>Si aún no has finalizado tu pago, podrás volver al paso inicial y elegir otra forma de pago. Una vez finalizada la compra no es posible cambiar la forma de pago.</p>
              <h4>6.- ¿Pagar electrónicamente tiene algún costo?</h4>
              <p>No, los pagos electrónicos realizados a través de Placetopay no generan costos adicionales para el comprador.</p>
              <h4>7.- ¿Qué debo hacer si mi transacción no concluyó?</h4>
              <p>Revisa si llegó un mail de confirmación. En caso de no haberlo recibido, contacta a <strong>soportepagos@anai.edu.ec</strong> para confirmar el estado.</p>
              <h4>8.- ¿Qué debo hacer si no recibí el comprobante?</h4>
              <p>Podrás contactar a la línea <strong>+59343703300</strong> o al correo <strong>soportepagos@anai.edu.ec</strong> para solicitar el reenvío del comprobante.</p>
            </div>
            <div style={{ padding: "12px 24px", borderTop: "1px solid #e9ecef", textAlign: "right" }}>
              <button onClick={() => setFaqOpen(false)} className="btn-modern" style={{ padding: "8px 24px", fontSize: "0.85rem" }}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {/* Logos */}
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 20, padding: "16px 0", marginBottom: 24 }}>
        <a href="http://www.placetopay.com" target="_blank" rel="noopener noreferrer">
          <img src="https://static.placetopay.com/placetopay-logo.svg" alt="Placetopay" style={{ height: 40 }} />
        </a>
        <img src={creditI} alt="Tarjetas de crédito" style={{ maxWidth: 500, width: "100%" }} />
      </div>
    </div>
  );
}
